// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1MiIc"};